import React, { Component } from 'react'
import { string, array } from 'prop-types'
import { Field } from 'redux-form'
import { FormGroup, Label, Input, FormFeedback, FormText } from 'reactstrap'
import { requiredRule, emailRule } from 'utils/validation'
import { translate } from 'react-i18next'

import './FormGroupText.css'

@translate()
export default class FormGroupText extends Component {
    static propTypes = {
        type: string,
        id: string,
        name: string.isRequired,
        label: string,
        placeholder: string,
        helper: string,
        error: string,
        validate: array,
        className: string
    }
    static defaultProps = {
        type: 'text',
        required: false,
        validate: []
    }

    state = {
        focused: false
    }

    componentWillMount() {
        this.requiredRule = requiredRule(this.props.t)
        this.emailRule = emailRule(this.props.t)
    }

    handleFocus = () => {
        const { onFocus } = this.props
        this.setState({ focused: true })
        onFocus && onFocus()
    }
    handleBlur = () => {
        const { onBlur } = this.props
        this.setState({ focused: false })
        onBlur && onBlur()
    }

    renderFormGroup = ({ type, id, name, value, label, placeholder, helper, valid, meta, errorMsg, change, t, i18n, tReady, className, ...otherProps }) => (
        <FormGroup className={`${errorMsg ? 'is-invalid' : ''} ${meta.dirty ? 'dirty' : ''}`}>
            {label && (
                <Label className={((!value && value !== 0) || value === '') && !this.state.focused ? 'labelDown' : ''} htmlFor={id}>
                    {label}
                </Label>
            )}
            <Input id={id} type={type} name={name} value={value} className={`TextField ${errorMsg ? 'is-invalid' : ''}`} placeholder={placeholder} {...otherProps} />
            {errorMsg && <FormFeedback>{errorMsg}</FormFeedback>}
            {helper && <FormText>{helper}</FormText>}
        </FormGroup>
    )
    renderInput = ({ input, meta, error, externalError, ...restParams }) => {
        // Process Field props
        const valid = errorMsg || (meta.touched && meta.invalid) ? false : null
        let errorMsg = valid === false ? error || meta.error : null
        if (externalError) {
            errorMsg = externalError
        }
        return this.renderFormGroup({ valid, errorMsg, meta, ...input, ...restParams })
    }
    render() {
        const { type, required, validate, onFocus, onBlur, ...restProps } = this.props
        return (
            <Field
                type={type}
                required={required}
                onFocus={this.handleFocus}
                onBlur={this.handleBlur}
                validate={[...(required ? [this.requiredRule] : []), ...(type === 'email' ? [this.emailRule] : []), ...validate]}
                {...restProps}
                component={this.renderInput}
            />
        )
    }
}



// WEBPACK FOOTER //
// src/components/FormGroup/FormGroupText.js